import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { ContextService } from 'src/core/services/context.service';
import { DocumentTemplateCategorySummariesDataService } from '../document-template-category.data';
import { DocumentTemplateCategoryEditorView } from './document-template-category-editor.view';

interface IDocumentTemplateCategoryEditorControllerProps {
    value: number | null;
    onChange: (value: IDocumentTemplateCategorySummary | null) => void;
    mode: ControlMode;
    setBusy(isBusy: boolean);
    label?: string;
    required?: boolean;
    onGetErrorMessage?: () => Promise<ValidationError[]>;
}

@observer
export class DocumentTemplateCategoryEditorController extends React.Component<IDocumentTemplateCategoryEditorControllerProps, any> {
    @resolve
    contextService: ContextService;

    @observable
    templateCategoriesDataService: DocumentTemplateCategorySummariesDataService;

    constructor(props: IDocumentTemplateCategoryEditorControllerProps) {
        super(props);
    }

    @autobind
    async templateCategoryQuery(searchKeywords?: string): Promise<QueryResult<IDocumentTemplateCategorySummary>> {
        this.props.setBusy(true);
       
        this.templateCategoriesDataService.searchKeywords = searchKeywords;
        this.templateCategoriesDataService.addSorting('id', 'asc');
        let items = await this.templateCategoriesDataService.load(query =>query);
        this.props.setBusy(false);
        return {
            items,
            totalCount: items.length
        };
    }

    componentDidMount() {
        this.templateCategoriesDataService = DocumentTemplateCategorySummariesDataService.make(this.contextService);
    }

    render() {
        if (this.templateCategoriesDataService == null) {
            return null;
        }

        return (
            <DocumentTemplateCategoryEditorView
                value={this.props.value}
                onChange={this.props.onChange}
                request={{ query: this.templateCategoryQuery, dataSet: this.templateCategoriesDataService }}
                mode={this.props.mode}
                label={this.props.label}
                required={this.props.required}
                onGetErrorMessage={this.props.onGetErrorMessage}
            />
        );
}
}



// WEBPACK FOOTER //
// ./src/app/general/document-template-categories/parts/document-template-category-editor.controller.tsx